<ng-container *ngIf="{ modern: invoice$ | async, legacy: legacyInvoice$ | async } as data">
<app-card-widget title="Information (old)" subtitle="{{data.modern?.number}} / {{data.modern?.new_number}}"
  *ngIf="data.modern">

  <form [formGroup]="form" id="invoice-info-form" (ngSubmit)="save(data.legacy)" novalidate>

    <div class="card-section-container">
      <div class="card-section">

        <app-text label="Bank Account" *ngIf="!edited">{{ data.modern.iban | ibanFormatter}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Bank Account" formControlName="bankAccount" [matAutocomplete]="iban"/>
          <mat-error
                     *ngIf="form.get('bankAccount').invalid && (form.get('bankAccount').dirty || form.get('bankAccount').touched)">
            <ng-container *ngIf="form.get('bankAccount').errors.required">
              IBAN is required.
            </ng-container>
            <ng-container *ngIf="form.get('bankAccount').errors.iban">
              IBAN is invalid.
            </ng-container>
          </mat-error>
        </mat-form-field>
      <mat-autocomplete #iban="matAutocomplete">
        <ng-container *ngIf="bankAccounts$ | async as bankAccounts">
          <mat-option *ngFor="let account of bankAccounts" [value]="account.iban">
            {{account.iban | ibanFormatter }} {{ account.verified_at ? '' : '(not verified)'}}
          </mat-option>
        </ng-container>
      </mat-autocomplete>

        <app-text label="Express Payment" *ngIf="!edited" [ngSwitch]="data.modern.express_payment">
          <span *ngSwitchCase="true">Yes</span>
          <span *ngSwitchDefault>No</span>
        </app-text>

        <mat-form-field *ngIf="edited">
          <mat-select placeholder="Express Payment" formControlName="expressPayment">
            <mat-option *ngFor="let option of expressPaymentChoices" [value]="option.value">
              {{option.label}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <app-text label="Source"><app-source-name [sourceId]="data.modern.source_id"></app-source-name></app-text>
        <app-text label="Source ID" *ngIf="data.modern.correlation_id">{{data.modern.correlation_id}}</app-text>
      </div>

      <div class="card-section">
        <app-text label="Created" *ngIf="!edited">{{data.modern.created_at | date}}</app-text>

        <app-text label="Original Invoice Number" *ngIf="!edited">{{data.modern.number}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput placeholder="Original Invoice Number" formControlName="number" />
        </mat-form-field>

        <app-text label="Due Date" *ngIf="!edited">{{data.modern.due_date | date}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput [matDatepicker]="dueDatePicker" placeholder="Due Date" formControlName="dueDate" />
          <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #dueDatePicker></mat-datepicker>
        </mat-form-field>

        <app-text label="Amount" *ngIf="!edited">{{data.modern.amount?.amount | currency:'EUR'}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput type="number" placeholder="Amount" formControlName="amount" />
        </mat-form-field>

      </div>
      <div class="card-section">

        <app-text label="Corona Invoice Number" *ngIf="!edited">{{data.modern.new_number}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput type="number" placeholder="Corona Invoice Number" formControlName="newInvoiceNumber" />
        </mat-form-field>

        <app-text label="Corona Reference Number" *ngIf="!edited">{{data.modern.new_reference_number}}</app-text>

        <mat-form-field *ngIf="edited">
          <input matInput type="number" placeholder="Reference Number" formControlName="newReferenceNumber" />
        </mat-form-field>

        <app-text label="Netvisor ID">{{data.modern.external_id}}</app-text>

        <app-text label="Lead Source" *ngIf="!edited">{{data.modern.lead_source?.name}}</app-text>
        <mat-form-field *ngIf="edited && !selectingLeadSource" (click)="selectLeadSource()">
          <input matInput type="text" placeholder="Lead Source" [value]="selectedLeadSource?.name"
            readonly="true" />
        </mat-form-field>
        <app-lead-source-auto-complete *ngIf="edited && selectingLeadSource" clearable field="name"
          (selected)="leadSourceSelected($event)" (cleared)="leadSourceCleared()">
        </app-lead-source-auto-complete>

        <app-text label="Responsible Seller" *ngIf="!edited">{{data.modern.responsible_seller?.name}}</app-text>
        <mat-form-field *ngIf="edited && !selectingResponsibleSeller" (click)="selectResponsibleSeller()">
          <input matInput type="text" placeholder="Responsible Seller" [value]="selectedResponsibleSeller?.name"
            readonly="true" />
        </mat-form-field>
        <app-partner-auto-complete *ngIf="edited && selectingResponsibleSeller" clearable field="name"
          [current]="selectedResponsibleSeller"
          (selected)="responsibleSellerSelected($event)"
          (cleared)="responsibleSellerCleared()">
        </app-partner-auto-complete>

      </div>

    </div>

  </form>

  <form [formGroup]="finalReportForm" id="invoice-info-final-report-form" (ngSubmit)="saveFinalReport(data.legacy)" novalidate>

    <div class="card-section-container" *ngIf="finalReportEdited">

      <div class="card-section">

        <mat-form-field>
          <input matInput type="email" placeholder="Final Report Email Recipients" formControlName="recipients" />
          <mat-hint>Leave empty to generate only. Separate multiple addresses with comma (,).</mat-hint>
        </mat-form-field>

      </div>

    </div>

  </form>

  <form [formGroup]="offerForm" id="invoice-info-offer-form" (ngSubmit)="saveOffer(data.legacy)" novalidate>

    <div class="card-section-container" *ngIf="offerEdited">

      <div class="card-section">

        <mat-form-field>
          <input matInput type="email" placeholder="Offer Email Recipients" formControlName="recipients" />
          <mat-hint>Leave empty to generate only. Separate multiple addresses with comma (,).</mat-hint>
        </mat-form-field>

      </div>

    </div>

  </form>

  <mat-menu #action="matMenu">
    <button mat-menu-item (click)="generateFinalReport(data.legacy)">Generate Final Report</button>
    <button mat-menu-item (click)="generateInvoiceNumber(data.legacy)">Generate Invoice Number</button>
    <button mat-menu-item (click)="generateOffer(data.legacy)">Generate Offer</button>
    <button mat-menu-item (click)="sendInvoice(data.legacy)">Send Invoice</button>
    <button mat-menu-item (click)="sendModifiedOriginalInvoice(data.legacy)">Send Modified Original Invoice</button>
    <!--
    <button mat-menu-item (click)="sendToAccounting(data.legacy)">Send to Accounting</button>
    -->
    <button mat-menu-item (click)="sendToAccountingNew(data.modern)">Send to Accounting</button>
  </mat-menu>

  <mat-card-actions align="end" *ngIf="finalReportEdited">
    <button type="submit" mat-button [disabled]="!finalReportForm.valid"
      form="invoice-info-final-report-form">Generate</button>
    <button type="button" mat-button (click)="cancelFinalReport()">Cancel</button>
  </mat-card-actions>

  <mat-card-actions align="end" *ngIf="offerEdited">
    <button type="submit" mat-button [disabled]="!offerForm.valid" form="invoice-info-offer-form">Generate</button>
    <button type="button" mat-button (click)="cancelOffer()">Cancel</button>
  </mat-card-actions>

  <mat-card-actions align="end" *ngIf="!offerEdited && !finalReportEdited">
    <button type="button" mat-button *ngIf="!edited" [disabled]="locked || !data.legacy" [matMenuTriggerFor]="action">Action</button>
    <button type="button" mat-button *ngIf="!edited" [disabled]="locked || !data.legacy" (click)="edit(data.legacy, data.modern)">Edit</button>
    <button type="submit" mat-button *ngIf="edited" [disabled]="!form.valid" form="invoice-info-form">Save</button>
    <button type="reset" mat-button *ngIf="edited" (click)="revert(data.legacy)">Cancel</button>
  </mat-card-actions>

</app-card-widget>
</ng-container>
